module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._t("default"), _vm._v(" "), _c('div', {
    staticClass: "activity-panel"
  }, [_c('ul', {
    staticClass: "box"
  }, _vm._l((_vm.t_data), function(item, i) {
    return _c('li', {
      key: i,
      staticClass: "content"
    }, [(item.imgUrl) ? _c('img', {
      staticClass: "i",
      attrs: {
        "src": item.imgUrl
      }
    }) : _vm._e()])
  }), 0)])], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2b96ff97", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2b96ff97"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/pc/homePage/components/plugins/panel/index.vue
// module id = 2570
// module chunks = 0